import { useState } from 'react';
import Modal from "./Modal"
import { resendInvite, deactivateUser, reactivateUser, sendResetUserPassword } from "../utils/apiCalls"
import { useAuth } from "../utils/AuthContext"
import DeactivateModal from './DeactivateModal';
import SendPasswordResetModal from './SendPasswordResetModal';

export default function UserInfo({ user: targetUser, setCloseModal, refreshUsers, locationId, clinicId } ) {
    const { token, user: authUser } = useAuth();
    const [message, setMessage] = useState('');
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const [showResetPWModal, setShowResetPWModal] = useState(false);

    if (!targetUser || !authUser ) return null;

    // permissions 
    // const isSuperAdmin = authUser.role === 'super_admin';
    // const isClinicAdmin = authUser.role === 'admin';
    // const viewingUser = targetUser.role === 'user';

    // admins can edit/deactivate users but not other admins 
    // const canEdit =
    //     isSuperAdmin ||
    //     (isClinicAdmin && viewingUser);

    // Resend welcome email
    const handleResendInvite = async () => {
        try {
            await resendInvite(token, targetUser.user_id);
            setMessage('Invitation resent successully');
        } catch (error) {
            console.error('Error resending invite', error);
            setMessage(error.message);
        }
        setShowResetPWModal(false);
    }

    const handleSendPasswordReset = async () => {
        try {
            await sendResetUserPassword(targetUser.user_id, token);
        } catch {
            setMessage('Something went wrong sending email, please try again')
        }
        setShowResetPWModal(false);
    };

    //Deactivate user
    const handleDeactivate = async () => {
        try {
            await deactivateUser(targetUser.user_id, token);
            setShowDeactivateModal(false);
            setMessage('User Deactivated');
            if (refreshUsers) refreshUsers(locationId || clinicId);
            setCloseModal(false);
        } catch (error) {
            console.error(error);
        }
    };

    const handleReactivate = async () => {
        try {
            await reactivateUser(targetUser.user_id, token);
            setShowDeactivateModal(false);
            setMessage('User Reactivated');
            if (refreshUsers) refreshUsers(locationId || clinicId);
            setCloseModal(false);
        } catch (error) {
            console.error(error);
        }
    };


    return (

        <Modal>
                <div className='flex items-start justify-between'>
                    <div>
                        <h2 className='text-lg font-bold text-docpgrPurple'>user details</h2>
                        <p className='text-sm text-slate-600'>
                            {targetUser.full_name}
                        </p>
                        <p className='text-sm text-slate-600'>
                            {targetUser.email}
                        </p>
                     </div>
                    {/* {!canEdit && (
                        <span className='text-xs ppx-2 py-1 rounded-full bg-slate-100 text-slate-500'>
                            view only
                        </span>
                    )} */}
                </div>

                {/* information  */}
                <div className='rounded-xl border border-slate-200 bg-white px-4 py-3 space-y-2'>
                    <div className='flex justify-between items-center'>
                        <span className='text-sm font-semibold text-slate-700'>
                            status
                        </span>

                        <div className='flex items-center gap-2'>
                            <span className={`text-xs px-2 py-1 rounded-full font-medium ${targetUser.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'} `}>
                                {targetUser.is_active ? 'active' : 'deactivated'}
                            </span>

                            {!targetUser.is_activated && (
                                <button onClick={handleResendInvite} className='text-xs text-docpgrPurple hover:underline'>
                                    resend invite
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* actions  */}
                <div className='space-y-3'>
                    {targetUser.is_activated && (
                        <button onClick={() => setShowResetPWModal(true)} className='w-full rounded-lg border border-docpgrPurple/30 bg-white px-4 py-2 text-sm font-semibold text-docpgrPurple hover:bg-docpgrPurple/5 hover:shadow-docpgr-purple-glow transition'>
                            reset password
                        </button>
                    )}
                    {targetUser.is_active ? (
                        <button onClick={() => setShowDeactivateModal(true)} className='w-full rounded-lg border border-red-300 bg-red-50 px-4 py-2 text-sm font-semibold text-red-700 hover:bg-red-100 transition'>
                            deactivate
                        </button>
                    ) : (
                        <button onClick={handleReactivate} className='w-full rounded-lg border border-green-300 bg-green-50 px-4 py-2 text-sm font-semibold text-green-700 hover:bg-green-100 transition'>
                            reactivate
                        </button>
                    )}
                </div>

                {/* footer  */}
                <div className='flex justify-end pt-2 border-t border-slate-200'>
                    <button onClick={() => setCloseModal(false)} className='px-4 py-2 rounded-lg text-sm font-semibold text-lsate-600 hover:bg-slate-100 transition'>
                        close
                    </button>
                </div>

                {message && <p className='text-xs text-slate-600'>{message}</p>}

                {showDeactivateModal && (
                    <DeactivateModal selectedName={targetUser.full_name} handleDeactivate={handleDeactivate} setShowModal2={setShowDeactivateModal} />
                )}

                {showResetPWModal && (
                    <SendPasswordResetModal userName={targetUser.full_name} onConfirm={handleSendPasswordReset} onCancel={() => setShowResetPWModal(false)} />
                )}
        </Modal>
    );
};